import React from 'react';
import './App.css';
import CustomNavbar from './components/CustomNavBar'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import watch1 from './Images/GarminWatchApp.png';
import watch1_thumb from './Images/GarminWatchApp_thumb.png';
import ImageGallery from 'react-image-gallery';
import logo from './Images/TrueNorth_garmin.png';
import CustomBtn from './components/CustomButton'
import  { FirebaseContext } from "./components/Firebase";
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';
//import "react-image-gallery/styles/css/image-gallery.css";
import './ImageGallery.css';
import { textAlign } from '@material-ui/system';

//function App() {

class TrueNorthGarmin extends React.Component {


render() {

  const boxStyle = { 
    width: 'fit-content', 
    background:'rgba(248, 248, 248, 0.6)', 
    borderRadius:'5px', 
    padding:'15px', 
    margin: '5px',
    minHeight: '500px',
    minWidth: '400px',
    boxShadow:'0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 6px 20px 0 rgba(0, 0, 0, 0.18)'
  };

  const images = [
    {
      original: watch1,
      thumbnail: watch1_thumb,
    },
  ]

  return (
    <div style={{height:'100%'}}>
      <div style={{minHeight:'92vh'}}>
      <CustomNavbar logo={true}></CustomNavbar>

      <Grid container spacing={0} style={{marginBottom:'20px'}}>
        <Grid item xs={12} md={6} style={{ padding:'25px 0px 45px 25px'}}>
             <ImageGallery items={images} showFullscreenButton={false} showPlayButton={false} showNav={false} />
        </Grid>
        <Grid item xs={12} md={6}>
            <Grid container direction="column" justify={'center'} alignItems={'center'} style={{marginLeft:'-10px' ,paddingTop:'30px'}}>
            <img src={logo} style={{maxWidth: '50%', marginBottom:'20px'}}/>
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"70%", textAlign:'center'}}>
                   - Conveniently access all your yachts data through the TrueNorth Server on your Garmin compatible watch.
            </Typography>  
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"70%", textAlign:'center'}}>
                   - Supports all fēnix®, quatix®, Forerunner® and MARQ™ watches.
            </Typography> 
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"70%", textAlign:'center'}}>
                   - Customize page layout and select available variables to suite your needs.
            </Typography> 
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"70%", textAlign:'center'}}>
                   - Requires a bluetooth connection to your smartphone which is connected to the network running the TrueNorth Server.
            </Typography> 
            <Typography variant="subtitle1" style={{marginTop:'5px',paddingBottom:'5px', color:'black', maxWidth:"70%", textAlign:'center'}}>
                   - The TrueNorth Garmin App is free to download but requires the TrueNorth Server which has a once off activation fee.  
            </Typography> 
            <Grid container direction="row" justify={'center'} alignItems={'flex-end'} style={{paddingTop:'25px'}}>
                <Link to="/Download" style={{textDecoration: 'none', margin:'-1% 0px 30px 0px'}}><CustomBtn click={null} name={'Download Now'}></CustomBtn></Link> 
            </Grid> 
                        
            </Grid>
        </Grid>
      </Grid>
      </div>

      <div style={{minHeight:'8vh', boxShadow:'0 0px 12px 0 rgba(0, 0, 0, 0.4), 0 0px 20px 0 rgba(0, 0, 0, 0.4)', backgroundColor:'#313131'}}>
      <Grid container direction="row" justify={'center'} alignItems={'center'} style={{height:'8vh'}}>
      <Typography variant="body2" style={{color:'white', textAlign: 'center'}}>
                  Contact us at truenorthsailingsoftware@gmail.com | +27-84-600-6091
    </Typography>
      </Grid>
      </div> 


    </div>
    );
  }
}

export default TrueNorthGarmin;
